<script>
    export let id;

    import {Link} from "svelte-routing";
    import { projects, researchers, publications, videos} from '../data.js';
    import Fa from 'svelte-fa';
    import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons';

    import Tag from '../Tag.svelte';
    import Video from '../Video.svelte';
    import ProjectsBar from '../ProjectsBar.svelte';

    $: project = projects[id];
    $: video_ids = projects[id].videos;

</script>

<main>
    <div class="row">
        <ProjectsBar />
        <h1 class="qualiperf">{id}</h1>

        <div class="row">
            <div class="col s12 m6 l6">
                <h2 class="qualiperf"><b>{project.title}</b></h2>
                <img src="/content/icons/Icon_{project.id}.png" alt="{project.id}"/>

                <h2 class="qualiperf">Researchers</h2>
                <div class="row">
                    {#each project.people as rid}
                        <div class="row">
                            <div class="col s12 m4 l4">
                                <Link to="researchers/{rid}">
                                    <img clas="qualiperf" src="/content/people/{rid}.png" height="100" alt="{rid}"
                                         title="More information"/>
                                </Link>
                                <br />
                                <b>{researchers[rid].name}</b>
                            </div>
                            <div class="col s12 m8 l8">
                                {researchers[rid].institute}<br />
                                {#each researchers[rid].tags as tag}
                                    <Tag {tag}/>
                                {/each}
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
            <div class="col s12 m6 l6">
                {#each video_ids as vid}
                    <Video id="{vid}" />
                {/each}

                <h2 class="qualiperf">Summary</h2>
                {#each project.tags as tag}
                    <Tag {tag}/>
                {/each}
                <br />
                <p class="summary">{project.summary}</p>
            </div>
        </div>
    </div>
</main>

<style>
    img{
        max-width:65%;
        max-height:65%
    }
    p.summary{
        text-align: justify;
    }
</style>

